import { ORDERS_SERVICE } from "@/services/orders.service.js";

const state = {postOrderOutput: false, getOrdersOutput: {}, getOrderByIdOutput: {}, postOrderWebhookOutput: false, putOrderStatusOutput: false, deleteOrderByIdOutput: false};

const actions = {
    //Service to create orders
    postOrder({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postOrderRequest');

        ORDERS_SERVICE.postOrder(input)
            .then(
                output => {
                    commit('postOrderSuccess', output);
                },
                error => {
                    commit('postOrderFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //
    getOrders({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getOrdersRequest');

        ORDERS_SERVICE.getOrders(queryParams)
            .then(
                output => {
                    commit('getOrdersSuccess', output);
                },
                error => {
                    commit('getOrdersFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get order details
    getOrderById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getOrderByIdRequest');

        ORDERS_SERVICE.getOrderById(id)
            .then(
                output => {
                    commit('getOrderByIdSuccess', output);
                },
                error => {
                    commit('getOrderByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //
    postOrderWebhook({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('postOrderWebhookRequest');

        ORDERS_SERVICE.postOrderWebhook()
            .then(
                output => {
                    commit('postOrderWebhookSuccess', output);
                },
                error => {
                    commit('postOrderWebhookFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update order status
    putOrderStatus({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putOrderStatusRequest');

        ORDERS_SERVICE.putOrderStatus(input)
            .then(
                output => {
                    commit('putOrderStatusSuccess', output);
                },
                error => {
                    commit('putOrderStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove Order items
    deleteOrderById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteOrderByIdRequest');

        ORDERS_SERVICE.deleteOrderById(queryParams)
            .then(
                output => {
                    commit('deleteOrderByIdSuccess', output);
                },
                error => {
                    commit('deleteOrderByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postOrder
    postOrderRequest(state) {
        state.postOrderOutput = null;
    },
    postOrderSuccess(state, output) {
        state.postOrderOutput = true;
    },
    postOrderFailure(state) {
        state.postOrderOutput = false;
    },

    //getOrders
    getOrdersRequest(state) {
    },
    getOrdersSuccess(state, output) {
        state.getOrdersOutput = output;
    },
    getOrdersFailure(state) {
        state.getOrdersOutput = false;
    },

    //getOrderById
    getOrderByIdRequest(state) {
    },
    getOrderByIdSuccess(state, output) {
        state.getOrderByIdOutput = output;
    },
    getOrderByIdFailure(state) {
        state.getOrderByIdOutput = false;
    },

    //postOrderWebhook
    postOrderWebhookRequest(state) {
        state.postOrderWebhookOutput = null;
    },
    postOrderWebhookSuccess(state, output) {
        state.postOrderWebhookOutput = true;
    },
    postOrderWebhookFailure(state) {
        state.postOrderWebhookOutput = false;
    },

    //putOrderStatus
    putOrderStatusRequest(state) {
        state.putOrderStatusOutput = null;
    },
    putOrderStatusSuccess(state, output) {
        state.putOrderStatusOutput = true;
    },
    putOrderStatusFailure(state) {
        state.putOrderStatusOutput = false;
    },

    //deleteOrderById
    deleteOrderByIdRequest(state) {
        state.deleteOrderByIdOutput = null;
    },
    deleteOrderByIdSuccess(state, output) {
        state.deleteOrderByIdOutput = true;
    },
    deleteOrderByIdFailure(state) {
        state.deleteOrderByIdOutput = false;
    },
};

export const orders = {
    namespaced: true,
    state,
    actions,
    mutations
};